var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5C0 7.19531 2.67188 4.5 6 4.5C9.30469 4.5 12 7.19531 12 10.5C12 13.8281 9.30469 16.5 6 16.5C2.67188 16.5 0 13.8281 0 10.5ZM8.69531 9.46875C8.95312 9.21094 8.95312 8.8125 8.69531 8.55469C8.4375 8.29688 8.03906 8.29688 7.78125 8.55469L5.25 11.0859L4.19531 10.0547C3.9375 9.79688 3.53906 9.79688 3.28125 10.0547C3.02344 10.3125 3.02344 10.7109 3.28125 10.9688L4.78125 12.4688C5.03906 12.7266 5.4375 12.7266 5.69531 12.4688L8.69531 9.46875Z",
    fill: "#20662E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckMark);
export default __webpack_public_path__ + "static/media/GreenCheckMark.6a70aa3b84b8b3f50bc2aee2ed4f1b8d.svg";
export { ForwardRef as ReactComponent };